import {apiRequest} from "./apiRequest";
import type {DeploymentHistoryResponse, RollbackRequest, RollbackResponse} from "@calendall/shared";

export async function getDeployments(): Promise<DeploymentHistoryResponse> {
  return apiRequest<DeploymentHistoryResponse>({path: "admin/deployments"});
}

export async function rollBack(request: RollbackRequest): Promise<RollbackResponse> {
  return apiRequest<RollbackResponse>({path: "admin/deployments/rollback", method: "POST", body: request});
}
